import { GETREQUESTOPTIONS, instance } from '../apiService';

export interface SyncRunSystem {
    systemId: string;
    name: string;
    versions: number[];
}

export interface SyncRunManufacturer {
    manufacturerId: string;
    name: string;
    outcome: 'created' | 'replaced' | 'updatedInPlace' | 'conflict';
    detail?: string;
}

export interface SyncRunVerification {
    ok: boolean;
    failures: {
        kind: 'system' | 'manufacturer';
        id: string;
        name?: string;
        detail: string;
    }[];
}

export type SyncRunKind = 'sync' | 'revoke';

export interface SyncRun {
    /** Sender-generated id shared with the data pipeline's own history row. */
    syncRunId?: string;
    /** What the run did. Rows predating the field are reported as 'sync'. */
    kind: SyncRunKind;
    occurredAt: string;
    actorName: string;
    source?: string;
    status: 'ok' | 'error';
    error?: string;
    systems: SyncRunSystem[];
    manufacturers: SyncRunManufacturer[];
    totals: {
        systems: number;
        versions: number;
        configs: number;
        files: number;
        manufacturers: number;
    };
    verification?: SyncRunVerification;
}

export const getSyncRuns = async (limit = 20): Promise<SyncRun[]> => {
    const response = await instance.get('/api/sync/runs', {
        ...GETREQUESTOPTIONS(),
        params: { limit },
    });
    return response.data.data;
};
